import React, {useEffect, useState} from 'react';
import {requestGetDVTJCUVPipeLineList} from "@pages/dvtjcuv/service/DVTJCUVPipelineService";
import DVTJCUVPipelineTableList, {DVTJCUVPipelineListMode} from "@pages/dvtjcuv/list/DVTJCUVPipelineTableList";
import Button from "react-bootstrap/Button";
import {
    DVTJCUVSearchCddJobParentTabs,
    DVTJCUVSearchCddJobSetReceiverListTabs
} from "@pages/dvtjcuv/common/SearchCddJobTabs";
import {processRequestCheckDVTJCUVEmailBrief} from "@pages/dvtjcuv/rundvtjcuv/RunDVUtil";
import DVTJCUVSearchCddJobChooseReceiverModal
    from "@pages/dvtjcuv/rundvtjcuv/search/searchcddjob/DVTJCUVSearchCddJobChooseReceiverModal";
import {ORDER_BY, ResponseCode} from "@app/constants/Common";
import {requestCandidates} from "@app/services/CandidateService";
import {
    requestGetExcludeReceiverIds,
    requestGetReceivers,
    requestDeleteReceivers, requestSaveReceivers
} from "@pages/dvtjcuv/service/DVTJCUVSearchCddJobService";
import {alertMessage, showMessage} from "@app/constants/Messages";
import {arrayToString} from "@app/utils/CommonUtils";
import CandidateListTable, {CandidateListMode} from "@pages/candidate/list/CandidateListTable";
import DVTJCUVSearchCddJobSourceMoreReceiverModal
    from "@pages/dvtjcuv/rundvtjcuv/search/searchcddjob/DVTJCUVSearchCddJobSourceMoreReceiverModal";

const DVTJCUVReceiversManuallyReleasedTabContent = (props) => {
    const [candidates, setCandidates] = useState([]);
    const [allCandidateIds, setAllCandidateIds] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [showChooseReceiverModal, setShowChooseReceiverModal] = useState(false);
    const [showSourceMoreModal, setShowSourceMoreModal] = useState(false);
    const [selectedCandidateIds, setSelectedCandidateIds] = useState([]);


    const {cddId, parentTab, onChangeRootTab} = props

    const fetchCandidates = async (canIds) => {
        const params = {
            order_by: ORDER_BY.DESC_UPDATE_DATE,
            search_conditions: {
                parent_tab: DVTJCUVSearchCddJobSetReceiverListTabs.RECEIVERS_MANUALLY_RELEASED_TAB.id,
            }
        }
        params.search_conditions.candidate_ids = canIds
        params.search_conditions.search_cdd_job_receiver_mode = true
        params.search_conditions.cdd_id = cddId


        const res = await requestCandidates(params);

        setCandidates(res.content.candidates);
        setAllCandidateIds(res.content.all_candidate_ids);
        setTotalCount(res.content.totalCount)
        setCurrentPage(res.content.page)
    }

    const fetchReceivers = async () => {
        const params = {
            order_by: ORDER_BY.DESC_UPDATE_DATE,
            parent_tab: DVTJCUVSearchCddJobSetReceiverListTabs.RECEIVERS_MANUALLY_RELEASED_TAB.id
        }
        params.cdd_id = cddId

        const res = await requestGetReceivers(params);
        if (res.sts_code === ResponseCode.SUCCESS) {
            const recIds = res.content?.map(item => {
                return item.receiver
            });
            if (recIds.length > 0) {
                fetchCandidates(recIds)
            } else {
                setCandidates([])
            }
        } else {
            alertMessage(res.sts_code)
        }
    }

    useEffect(() => {
        if (cddId) {
            fetchReceivers()
        }
    }, [cddId]);

    const onStartCheckEmailBriefConditions = async (condition = {}) => {
        condition.candidate_id = cddId
        condition.receiver_ids = []
        selectedCandidateIds.forEach(recId => {
            if (recId) {
                condition.receiver_ids.push(recId)
            }
        })
        const result = await processRequestCheckDVTJCUVEmailBrief(condition)
        if (result) {
            onChangeRootTab(DVTJCUVSearchCddJobParentTabs.SEND_EMAIL_BRIEF_UV_TAB)
        }
    }

    const onAddReceivers = (recIds) => {
        if (!recIds || recIds.length === 0) {
            return
        }
        const request = {
            cdd_id: cddId,
            receiver_ids: recIds,
            parent_tab: DVTJCUVSearchCddJobSetReceiverListTabs.RECEIVERS_MANUALLY_RELEASED_TAB.id
        }
        requestSaveReceivers(request).then(res => {
            if (res.sts_code === ResponseCode.SUCCESS) {
                const notExistsRecIds = res.content.not_exist_rec_ids
                const successRecIds = res.content.success_rec_ids
                // showMessage(
                //     `Số receiver Ids lưu thành công: ${successRecIds.length} ${notExistsRecIds.length ? '\nReceiverIds lưu thất bại: ' + arrayToString(notExistsRecIds) : ''}`)
                fetchReceivers()
            } else {
                showMessage(res.message, true, true)
            }
        }).finally(() => {
            setShowSourceMoreModal(false)
            setShowChooseReceiverModal(false);
        });
    }

    const onDeleteReceivers = (recIds) => {
        if (!recIds || recIds.length === 0) {
            return
        }
        const request = {
            cdd_id: cddId,
            receiver_ids: recIds,
            parent_tab: DVTJCUVSearchCddJobSetReceiverListTabs.RECEIVERS_MANUALLY_RELEASED_TAB.id
        }
        requestDeleteReceivers(request).then(res => {
            if (res.sts_code === ResponseCode.SUCCESS) {
                const notExistsRecIds = res.content.not_exist_rec_ids
                const successRecIds = res.content.success_rec_ids
                // showMessage(
                //     `Số receiver Ids lưu thành công: ${successRecIds.length} ${notExistsRecIds.length ? '\nReceiverIds lưu thất bại: ' + arrayToString(notExistsRecIds) : ''}`)
                fetchReceivers()
            } else {
                showMessage(res.message, true, true)
            }
        }).finally(() => {
            setShowSourceMoreModal(false)
            setShowChooseReceiverModal(false);
        });
    }

    const onSelectCandidates = (canIds) => {
        setSelectedCandidateIds(canIds)
    }

    return (
        <>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>Receivers MANUALLY Released</h3>
                    <div className={'card-tools'}>
                        <div className={'row'}>
                            <Button className={'btn btn-default mr-3'} onClick={() => {
                                setShowSourceMoreModal(true)
                            }}>
                                Source more Receivers
                            </Button>
                            <Button className={'btn btn-default mr-3'} onClick={() => setShowChooseReceiverModal(true)}>
                                Copy List Receivers
                            </Button>
                            <button type='button'
                                    className='btn btn-info btn-sm'
                                    disabled={selectedCandidateIds.length === 0}
                                    onClick={() =>
                                        onStartCheckEmailBriefConditions()
                                    }
                            >
                                Gửi Email Brief UV
                            </button>
                        </div>
                    </div>
                </div>
                <div className='card-body'>
                    <CandidateListTable
                        showBtnSelect
                        hideBtnActions
                        candidates={candidates}
                        allCandidateIds={allCandidateIds}
                        mode={CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_RECEIVER_MANUALLY_RELEASE}
                        totalCount={totalCount}
                        onReturnSelectedItems={onSelectCandidates}
                        onDeleteReceiverManuallyRelease={onDeleteReceivers}
                    />
                </div>
            </div>

            {showChooseReceiverModal &&
                <DVTJCUVSearchCddJobChooseReceiverModal
                    cddId={cddId}
                    isShow={showChooseReceiverModal}
                    onReturnSelectItems={onAddReceivers}
                    onClose={() => setShowChooseReceiverModal(false)}
                />
            }

            {showSourceMoreModal &&
                <DVTJCUVSearchCddJobSourceMoreReceiverModal
                    isShow={showSourceMoreModal}
                    cddId={cddId}
                    onAddReceivers={onAddReceivers}
                    onClose={() => setShowSourceMoreModal(false)}
                />
            }
        </>
    )
}
export default DVTJCUVReceiversManuallyReleasedTabContent;
